<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before:always"></div>
<p class="P_Standard__And__Dante_MT_Std__And__12pt__And__Centre_Alignment__And__Left_Indent__And__Right_Indent__And__Page_Break"><span class="C_Current__And__Georgia">TO</span></p>
<p class="P_Standard__And__Dante_MT_Std__And__12pt__And__Left_Indent__And__Right_Indent__OPENPAR_1_CLOSEPAR_"> </p>
<p class="P_Standard__And__Dante_MT_Std__And__12pt__And__Centre_Alignment__And__Left_Indent__And__Right_Indent"><span class="C_Current__And__Georgia">P.H.K-K.</span></p>
<p class="P_Standard__And__Dante_MT_Std__And__12pt__And__Centre_Alignment__And__Left_Indent__And__Right_Indent"><span class="C_Current__And__Georgia">P.B., M.T, E.C.</span></p>
<p class="P_Standard__And__Dante_MT_Std__And__12pt__And__Left_Indent__And__Right_Indent__OPENPAR_1_CLOSEPAR_"> </p>
<p class="P_Standard__And__Dante_MT_Std__And__12pt__And__Left_Indent__And__Right_Indent__OPENPAR_1_CLOSEPAR_"> </p>
<p class="P_Standard__And__Dante_MT_Std__And__12pt__And__Left_Indent__And__Right_Indent__OPENPAR_1_CLOSEPAR_"> </p>
<p class="P_Standard__And__Dante_MT_Std__And__12pt__And__Left_Indent__And__Right_Indent__OPENPAR_1_CLOSEPAR_"> </p>
<p class="P_Standard__And__Dante_MT_Std__And__12pt__And__Left_Indent__And__Right_Indent__OPENPAR_1_CLOSEPAR_"> </p>
<p class="P_Standard__And__Dante_MT_Std__And__12pt__And__Left_Indent__And__Right_Indent__OPENPAR_1_CLOSEPAR_"> </p>
<p class="P_Standard__And__Dante_MT_Std__And__12pt__And__Left_Indent__And__Right_Indent__OPENPAR_1_CLOSEPAR_"> </p>
<p class="P_Standard__And__Dante_MT_Std__And__12pt__And__Left_Indent__And__Right_Indent__OPENPAR_1_CLOSEPAR_"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section-0003.vue?c0c61f48